import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { NgForm } from '@angular/forms';
import { OverlayPanel } from 'primeng/overlaypanel';
import { Table } from 'primeng/table';
import { CustoMedio } from 'src/app/admihair/api/dto/custo-medio';
import { Empresa } from 'src/app/admihair/api/dto/empresa';
import { EntradaEstoque } from 'src/app/admihair/api/dto/entrada-estoque';
import { EntradaProduto } from 'src/app/admihair/api/dto/entrada-produto';
import { Fornecedor } from 'src/app/admihair/api/dto/fornecedor';
import { ItemProduto } from 'src/app/admihair/api/dto/item-produto';
import { CustoService } from 'src/app/admihair/service/custo.service';
import { EntradaEstoqueService } from 'src/app/admihair/service/entrada-estoque.service';
import { ErroService } from 'src/app/admihair/service/erro.service';
import { FornecedorService } from 'src/app/admihair/service/fornecedor.service';
import { ItemProdutoService } from 'src/app/admihair/service/item-produto.service';
import { UtilStorageService } from 'src/app/admihair/service/util-storage.service';
import { AdmihairBaseComponent } from '../../../admihair-base.component';

@Component({
  selector: 'app-entrada-inserir',
  templateUrl: './entrada-inserir.component.html',
  styleUrls: ['./entrada-inserir.component.scss']
})
export class EntradaInserirComponent extends AdmihairBaseComponent implements OnInit {

  loadingPrincipal: boolean = true;
  empresaSelecionada?: Empresa;
  mostrarDialogProduto: boolean = false;
  progressoRequisicao: boolean = false;
  listaFornecedores: Fornecedor[] = [];
  entradaEstoque: EntradaEstoque = {
    nfEntrada: 0,
    dataNf: new Date(),
    valorFrete: 0,
    totalNf: 0
  }

  loadingTableProdutosDisponiveis: boolean = false;
  listaEntradaProduto: EntradaProduto[] = [];
  listaProdutosDisponiveis: ItemProduto[] = [];
  sucessoSalvar: boolean = false;
  linkEditar: string = '';
  totalItens: number = 0;

  overlayPanelAberto?: OverlayPanel;
  @ViewChild('f') form?: NgForm;
  @ViewChild('filter') filter!: ElementRef;


  entradaProdutoSelecionada?: EntradaProduto;
  valorVendaSugerido: number = 0;
  custoMedio: CustoMedio = {
    custoFixo: 0,
    imposto: 0
  };
  percentualFrete: number = 0;

  constructor(private entradaEstoqueService: EntradaEstoqueService,
    private itemProdutoService: ItemProdutoService,
    private fornecedorService: FornecedorService,
    private custoService: CustoService,
    utilStorageService: UtilStorageService,
    erroService: ErroService) {
    super(erroService, utilStorageService)
  }

  ngOnInit(): void {
    this.permissaoInserir = this.verificarPermissao('PERM_INSERIR_ENTRADA');
    this.empresaSelecionada = this.getEmpresa();
    if (this.permissaoInserir) {
      this.loadingPrincipal = true;
      this.obterCustos();
    }
  }

  obterCustos() {
    this.custoService.obterDadosParaPrecificacao(this.getEmpresa().id).subscribe({
      next: (data: CustoMedio) => {
        this.custoMedio = data;
        this.buscarFornecedores();
      },
      error: (err: any) => {
        this.loadingPrincipal = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  buscarFornecedores() {
    this.fornecedorService.listarPorEmpresaId(this.empresaSelecionada?.id).subscribe({
      next: (data: Fornecedor[]) => {
        this.listaFornecedores = data;
        this.loadingPrincipal = false;
      },
      error: (err: any) => {
        this.loadingPrincipal = false;
        this.exibirMensagemErro(err);
      }
    })
  }

  salvar() {
    this.progressoRequisicao = true;
    this.entradaEstoque.empresa = this.empresaSelecionada;
    this.entradaEstoque.usuario = this.getUsuarioLogadoSistema().id;
    let listaEntradaProdutoFormatada: EntradaProduto[] = [];
    for (const item of this.listaEntradaProduto) {
      let entradaProduto: EntradaProduto = {
        itemProduto: { id: item.itemProduto?.id, valorVenda: item.itemProduto?.valorVenda },
        quantidade: item.quantidade,
        valorCompra: item.valorCompra,
        validadeLote: item.validadeLote
      }
      listaEntradaProdutoFormatada.push(entradaProduto);
    }
    this.entradaEstoque.listaEntradaProduto = listaEntradaProdutoFormatada;

    this.entradaEstoqueService.salvar(this.entradaEstoque).subscribe({
      next: (data: EntradaEstoque) => {
        this.progressoRequisicao = false
        this.limparFormulario();
        this.listaEntradaProduto = [];
        this.linkEditar = `/apps/entrada/editar/${data.id}`;
        this.sucessoSalvar = true;
        this.exibirMensagemSucesso();
      },
      error: (err: any) => {
        this.progressoRequisicao = false;
        this.sucessoSalvar = false;
        this.exibirMensagemErro(err);
      }
    });
  }


  adicionarProduto(item: ItemProduto) {
    this.listaEntradaProduto.push({
      itemProduto: item,
      quantidade: 0,
      valorCompra: 0
    });

    this.removerItemListaDisponiveis(item)
    this.calcularTotalItens();
    this.mostrarDialogProduto = false;


  }

  onItemChange(item: EntradaProduto) {

    item.quantidade = Number(item.quantidade) || 0;
    item.valorCompra = Number(item.valorCompra) || 0;

    this.calcularTotalItens();
  }

  exibirOverlayValorSugerido(event: Event, panel?: OverlayPanel, item?: EntradaProduto) {

    if (item) {
      this.calcularValorSugerido(item);
      this.valorVendaSugerido = item.valorSugerido ?? 0;
    }
    this.entradaProdutoSelecionada = item;
    setTimeout(() => panel?.show(event), 250)

  }

  fecharOverlayValorSugerido() {
    if (this.entradaProdutoSelecionada?.itemProduto) {
      this.entradaProdutoSelecionada.itemProduto.valorVenda = this.valorVendaSugerido;
      this.entradaProdutoSelecionada = undefined;
    }
  }


  calcularTotalItens() {
    this.totalItens = this.listaEntradaProduto.reduce((total, item) => {
      const subtotal = (item.quantidade ?? 0) * (item.valorCompra ?? 0);
      return total + subtotal;
    }, 0);

    this.atribuirTotalNf();
  }

  atribuirTotalNf() {
    if (this.entradaEstoque.valorFrete) {
      return;
    }
    this.entradaEstoque.totalNf = this.totalItens;
  }

  calcularPercentualFrete() {
    const valorFrete = this.entradaEstoque.valorFrete ?? 0;
    const totalNf = this.entradaEstoque.totalNf ?? 0;

    if (totalNf === 0) {
      this.percentualFrete = 0;
    } else {
      this.percentualFrete = (valorFrete * 100) / totalNf;
    }

  }

  calcularValorSugerido(item: EntradaProduto) {
    this.calcularPercentualFrete();

    const valorFrete = (item.valorCompra ?? 0) * this.percentualFrete / 100;

    const valorLucroDesejado = (item.valorCompra ?? 0) * (item.itemProduto?.lucro ?? 0) / 100;

    const valorComposicao = (item.valorCompra ?? 0)
      + valorFrete + valorLucroDesejado;

    const percentualSugestaoInicial = this.custoMedio.custoFixo
      + (item.itemProduto?.comissaoVenda ?? 0)
      + this.custoMedio.imposto;

    const valorSugestaoInicial = valorComposicao
      + (percentualSugestaoInicial * valorComposicao / 100);

    const diferencaComposicao = (valorSugestaoInicial - valorComposicao)
      * percentualSugestaoInicial / 100;

    const valorCalculado = valorSugestaoInicial + diferencaComposicao
      + (diferencaComposicao * percentualSugestaoInicial / 100);

    item.valorSugerido = valorCalculado;

  }


  excluirProduto(item: EntradaProduto) {
    const posicao = this.listaEntradaProduto.indexOf(item);

    if (posicao >= 0) {
      this.listaEntradaProduto.splice(posicao, 1);
      this.calcularTotalItens();
    }
  }

  removerItemListaDisponiveis(item: ItemProduto) {
    const posicao = this.listaProdutosDisponiveis.indexOf(item);
    this.listaProdutosDisponiveis.splice(posicao, 1);
  }




  abrirDialogProduto() {
    this.mostrarDialogProduto = true;
    this.loadingTableProdutosDisponiveis = true;
    this.itemProdutoService.listarPorEmpresaIdEStatus(this.empresaSelecionada?.id, true).subscribe({
      next: (data: ItemProduto[]) => {
        this.listaProdutosDisponiveis = data.filter(produtoDisponivel =>
          !this.listaEntradaProduto.some(entrada =>
            entrada.itemProduto?.id === produtoDisponivel.id)
        );
        this.loadingTableProdutosDisponiveis = false;
      },
      error: (err: any) => {
        this.loadingTableProdutosDisponiveis = false;
        this.exibirMensagemErro(err);
      }
    });
  }

  buscar(table: Table, event: Event) {
    table.filterGlobal((event.target as HTMLInputElement).value, 'contains');
  }

  limpar(table: Table) {
    table.clear();
    this.filter.nativeElement.value = '';
  }

  ocultarMensagem() {
    if (this.messagemVisivel) {
      this.messagemVisivel = false;
    }
  }

  limparFormulario() {
    this.form?.reset();
  }

  trackByFn(index: number, item: any): any {
    return item.id ?? index;
  }

}
